import * as React from "react";
import { ChargeRow, TableWrapper } from "../styles";
import { Button, Label } from "react-bootstrap";
import { IFile } from "../file";
import { IInsuranceDetails } from "@nkr/models/insurance-details";
import { ChargeStatus } from "@nkr/enums/index";
import UploadFile from "../upload-file";
import NonGlobalInsurance from "../non-global-insurance";

interface IProps {
    hospitalCharges: string,
    validHospitalCharges: boolean,
    hospitalChargesFile: string,
    selectedHospitalChargesFile: IFile,
    validHospitalChargesFile: boolean,
    hospitalChargeStatus: ChargeStatus,
    hospitalChargeComments: string,
    recipientCenter: string,
    recipientAlias: string,
    disputedBy: string,
    insurance: IInsuranceDetails,
    viewOnly: boolean,
    dirty: boolean,
    onHospitalChargesChange: (cost: string) => void
    onHospicalChargesFileChange: (file: File, type: string) => void,
}

interface IState {
    showInsurance: boolean
}

class NonGlobal extends React.Component<IProps, IState> {
    readonly state: IState = {
        showInsurance: false
    }

    handleHospitalChargesFileChange = (file: File) => {
        this.props.onHospicalChargesFileChange(file, 'hospital-charges');
    }

    handleHospitalChargesChange = (e: React.FormEvent<HTMLInputElement>) => {
        this.props.onHospitalChargesChange(e.currentTarget.value);
    }

    handleShowInsurance = () => {
        this.setState({
            showInsurance: true
        });
    }

    handleCloseInsurance = () => {
        this.setState({
            showInsurance: false
        });
    }

    render = () => {
        const disputedBy = this.props.disputedBy != '' ? `${this.props.disputedBy} @ ${this.props.recipientCenter}` : this.props.recipientCenter;
        const { hospitalCharges, hospitalChargeStatus, hospitalChargeComments } = this.props;
        const hospitalClassName = hospitalChargeStatus == ChargeStatus.Disputed ? 'no-border' : '';

        return (
            <>
                <div style={{ marginBottom: 10 }}>Non SBS, Private-Insurance, Non-Global</div>

                <ol style={{ listStyle: "decimal", marginBottom: 25 }}>
                    <li>
                        <strong>Physician Donor Nephrectomy:</strong>
                        <ol style={{ listStyle: "upper-alpha" }}>
                            <li>
                                Private insurance is primary and there is no global arrangement, then Recipient Center shall make the necessary
                                information available so that the donor physicians can bill the Recipient’s insurance directly.
                            </li>
                        </ol>
                    </li>
                    <li style={{ marginTop: 5 }}>
                        <strong>Hospital Donor Nephrectomy:</strong>
                        <ol style={{ listStyle: "upper-alpha" }}>
                            <li>
                                If a center is not subject to the SBS the Donor Center shall bill the Recipient Center for the donor organ recovery
                                cost by providing a copy of their most recently filed Medicare Cost Report, Worksheet D-4, Part I, which documents
                                the cost per day and the appropriate cost to charge ratios along with a worksheet that reduces the Donor Center bill from charges to cost.
                                <span style={{ fontWeight: 600 }}>
                                    <a href="/pdf/form-d4-part1.pdf" target="_blank" style={{ marginLeft: 20, marginRight: 10 }}>D-4 Worksheet - Part 1 (PDF)</a>
                                    <a href="/pdf/form-d4-instructions.pdf" target="_blank">D-4 Worksheet Instructions (PDF)</a>
                                </span>
                            </li>
                        </ol>
                    </li>
                </ol>

                <TableWrapper>
                    <thead>
                        <tr>
                            <th>Fee</th>
                            <th>Supporting Documents</th>
                            <th>Details</th>
                            <th>Rate</th>
                            <th className='amount'>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Physician Donor Nephrectomy</td>
                            <td></td>
                            <td>Bill private insurance directly.</td>
                            <td><Button bsSize="xs" onClick={this.handleShowInsurance}>View Insurance</Button></td>
                            <td></td>
                        </tr>

                        <tr style={{ backgroundColor: '#eee' }}>
                            <td>Anesthesia</td>
                            <td></td>
                            <td>Bill private insurance directly.</td>
                            <td><Button bsSize="xs" onClick={this.handleShowInsurance}>View Insurance</Button></td>
                            <td></td>
                        </tr>

                        {hospitalChargeStatus == ChargeStatus.Disputed && (
                            <tr>
                                <td colSpan={5} className='text-danger' style={{ borderTop: '1px solid #ddd' }}>
                                    <div className='bg-danger' style={{ padding: 5, borderRadius: 4 }}><strong>This charge was disputed by {disputedBy}: {hospitalChargeComments}</strong></div>
                                </td>
                            </tr>
                        )}

                        <tr>
                            <td className={hospitalClassName}>Hospital Donor Nephrectomy</td>
                            <td className={hospitalClassName} colSpan={3}>
                                <UploadFile
                                    elementName="hospital-charges"
                                    valid={this.props.dirty ? this.props.validHospitalChargesFile : true}
                                    disable={this.props.viewOnly}
                                    onSelectFile={this.handleHospitalChargesFileChange}
                                />

                                <div style={{ fontSize: 12, marginTop: 3 }}>(Provide a copy of your most recently filed Medicare Cost Report, Worksheet D-4, Part I)</div>
                            </td>
                            <td className={hospitalClassName + ' amount'}>
                                {this.props.viewOnly == false ?
                                    <input type="text" className="form-control pull-right" style={{ width: '50%', textAlign: "right", border: this.props.dirty && !this.props.validHospitalCharges ? "2px solid red" : "1px solid #ccc" }} maxLength={24} value={hospitalCharges} onChange={this.handleHospitalChargesChange} />
                                    :
                                    <div style={{ padding: "6px 12px" }}>{this.props.hospitalCharges}</div>
                                }
                            </td>
                        </tr>

                        {this.props.hospitalChargesFile != '' && (
                            <tr>
                                <td className='no-border'></td>
                                <td className='no-border' colSpan={4}>Supporting document has been uploaded...</td>
                            </tr>
                        )}

                        {this.props.selectedHospitalChargesFile != null && this.props.selectedHospitalChargesFile.file != null && (
                            <tr>
                                <td colSpan={5} style={{ borderTop: '0 none', textAlign: 'center' }}><Label bsStyle='primary' style={{ fontSize: '100%' }}>Hospital Donor Nephrectomy file to upload: {this.props.selectedHospitalChargesFile.file.name}</Label></td>
                            </tr>
                        )}

                    </tbody>
                </TableWrapper>

                <NonGlobalInsurance
                    show={this.state.showInsurance}
                    recipientCenter={this.props.recipientCenter}
                    recipientAlias={this.props.recipientAlias}
                    data={this.props.insurance}
                    onClose={this.handleCloseInsurance}
                />
            </>
        );
    }
}

export default NonGlobal;